/**
 * @generated SignedSource<<e2fdc11678bae8d755111d2562a169f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalEditMainContent_Signal$data = {
  readonly body: string | null;
  readonly formattedBody: string | null;
  readonly id: string;
  readonly title: string;
  readonly updatedBySessionId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalLinkedContent_signal">;
  readonly " $fragmentType": "WorkspaceSignalEditMainContent_Signal";
};
export type WorkspaceSignalEditMainContent_Signal$key = {
  readonly " $data"?: WorkspaceSignalEditMainContent_Signal$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalEditMainContent_Signal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceSignalEditMainContent_Signal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedBody",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedBySessionId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceSignalLinkedContent_signal"
    }
  ],
  "type": "SignalWorkspace",
  "abstractKey": null
};

(node as any).hash = "0a41a4359d48aba73d5711600ce04577";

export default node;
